<template>
  <div>
    <form-data :list="formlist" @getAuth="getAuth" />
  </div>
</template>

<script>
import "./adduser.less";
import { typeattrtmpls, submitteampremembers, registerinfo } from "@/libs/api";
import formData from "@/components/form";
import { Dialog } from "vant";
import { setStorage, getStorage } from "@/libs/utils";

export default {
  name: "userlist",
  components: {
    formData
  },
  data() {
    return {
      formlist: [],
      params: {}
    };
  },
  methods: {
    getAuth(data) {
      if (data) {
        //读取缓存

        if (this.params.fromrole == 1) {
          try {
            var typeid = this.params.typeid;
            var membervalue = "membervalue" + typeid;
            var aindex = this.params.index;
            var value = getStorage(membervalue) ? getStorage(membervalue) : [];
            if (value) {
              // Do something with return value
              if (value[aindex] == undefined) {
                value[aindex] = {};
              }
            } else {
              value[aindex] = {};
            }

            value[aindex].list = data;

            try {
              setStorage(membervalue, value, true);
              //跳转 url

              this.$router.replace({
                name: "apply",
                params: {
                  matchid: this.$route.params.matchid,
                  typeid: this.$route.params.typeid,
                  aindex: aindex
                },
                query: this.$route.query
              });
            } catch (e) {
              // console.log(e);
            }
          } catch (e) {
            // console.log(e);
            // Do something when catch error
          }
        } else {
          this.params.json = JSON.stringify([data]);
          delete this.params.info;
          submitteampremembers(this.params).then(res => {
            if (res.status == 200) {
              //判断

              if (this.$route.params.from == "share") {
                Dialog.alert({
                  title: "提示",
                  message: "信息填写成功"
                }).then(() => {
                  // on close
                  this.$router.replace({ name: "apply", params: this.params });
                });
              } else {
                this.$router.replace({ name: "member", params: this.params });
              }
            }
          });
        }
      }
    },
    addlist() {
      let matchid = this.params.matchid;
      let typeid = this.params.typeid;
      let userinfo = getStorage("userInfo");
      let urid = userinfo.urid;
      if (this.params.form) {
        this.params.form.attrs.forEach(item => {
          if (item.type == 6 || item.type == 3 || item.type == 9) {
            if (typeof item.options == "string") {
              item.options = JSON.parse(item.options);
            }
          }
        });
        this.formlist.push(...this.params.form.attrs);
      } else if (this.params.info) {
        if (this.params.fromrole) {
          let rule = this.params.formrule.attrs;
          let listdata = JSON.parse(this.params.info.memberinfos);
          rule.forEach(itemo => {
            listdata.forEach(item => {
              if (item.key_name == itemo.key_name) {
                if (item.type == 6 || item.type == 3 || item.type == 9) {
                  if (typeof item.options == "string") {
                    item.options = JSON.parse(item.options);
                  }
                }
                itemo.value = item.value;
                itemo.options = item.options;
              }
            });
          });
          this.formlist.push(...rule);
        } else {
          typeattrtmpls({ matchid: matchid, typeid: typeid, urid: urid }).then(
            res => {
              if (res.status == 200) {
                let forms = [];
                res.data.list.forEach((item, index) => {
                  if (item.amount > 1) {
                    var title = item.title;
                    for (var i = 1; i <= item.amount; i++) {
                      item.title = title + i;
                      item.aindex = index;
                      forms.push(item);
                    }
                  } else {
                    item.aindex = index;
                    forms.push(item);
                  }
                });
                let rule = {};
                if (forms.length == 1) {
                  rule = forms[0].attrs;
                } else {
                  rule = forms[this.params.index].attrs;
                }
                let listdata = JSON.parse(this.params.info.memberinfos);
                rule.forEach(itemo => {
                  listdata.forEach(item => {
                    if (item.key_name == itemo.key_name) {
                      if (item.type == 6 || item.type == 3 || item.type == 9) {
                        if (typeof item.options == "string") {
                          item.options = JSON.parse(item.options);
                        }
                      }
                      itemo.value = item.value;
                      itemo.options = item.options;
                    }
                  });
                });
                this.formlist.push(...rule);
              }
            }
          );
        }
      } else if (this.params.json) {
        let info = this.params.json;
        this.formlist.push(...info.list);
      } else {
        typeattrtmpls({ matchid: matchid, typeid: typeid, urid: urid }).then(
          res => {
            if (res.status == 200) {
              res.data.list[0].attrs.forEach(item => {
                if (item.type == 6 || item.type == 3 || item.type == 9) {
                  if (typeof item.options == "string") {
                    item.options = JSON.parse(item.options);
                  }
                }
              });
              this.formlist.push(...res.data.list[0].attrs);
            }
          }
        );
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      let param = this.$route.params;
      let arr1 = Object.keys(param);
      if (arr1.length == 0) {
        this.params = getStorage("adduser");
      } else {
        this.params = this.$route.params;
        setStorage("adduser", this.params, true);
      }
      if (this.params.riid) {
        registerinfo(this.params).then(res => {
          if (res.status == 200) {
            this.formlist.push(...res.data.attrs);
          } else {
            this.formlist = [];
          }
        });
      } else {
        this.addlist();
      }
    });
  }
};
</script>